import { useTranslation } from "react-i18next";
import { Homework } from "../models/Homework";
import { Tag, TagLabel } from "@chakra-ui/react";
import { useMemo } from "react";

type Props = {
  status: Homework["status"];
};

export default function HomeworkStatusChip({ status }: Props) {
  const { t } = useTranslation();

  const [label, colorSchema] = useMemo(() => {
    switch (status) {
      case "STARTED":
        return [t("common.labels.started"), "yellow"];
      case "APPROVED":
        return [t("common.labels.approved"), "green"];
      case "REJECTED":
        return [t("common.labels.rejected"), "red"];
      case "DONE":
        return [t("common.labels.done"), "orange"];
      case "TODO":
        return [t("common.labels.todo"), "white"];
    }
  }, [status, t]);

  return (
    <Tag colorScheme={colorSchema} size="lg">
      <TagLabel>{label}</TagLabel>
    </Tag>
  );
}
